import { ChartMargins } from '/src/lib/types';

/**
 * Margins
 */

export type MarginsProps = ChartMargins;

export class Margins implements MarginsProps {
  top = 0;
  right = 0;
  bottom = 0;
  left = 0;
  xAxis = 0;
  yAxis = 0;
  [key: string]: number;

  constructor(margins: Partial<ChartMargins>) {
    if (margins) {
      for (const margin in margins) {
        if (margins[margin]) this[margin] = margins[margin];
      }
    }
  }
}
